module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"SocialNetworkLinks":{"label":"Sledujte nás"}},"de":{"SocialNetworkLinks":{"label":"Folgen Sie uns"}},"sk":{"SocialNetworkLinks":{"label":"Sledujte nás"}}}')
  delete Component.options._Ctor
}
